<div class="sheet">
  <div class="line">
    <h4 class="upper">{{ 'CART.VARIANT_TITLE' | translate }}</h4>
    <img class="icon-xl" (click)="close()" [src]="'close.svg' | themeSource" alt="close" />
  </div>

  @for (variant of variants(); track variant.id) {
    <app-cart-line-item
      class="border-line"
      [line]="variant"
      (increase)="increase(variant.id)"
      (decrease)="decrease(variant.id)"
      (editClick)="editVariant(variant.id)">
    </app-cart-line-item>
  }

  <button class="btn add-new" (click)="addNewVariant()">
    {{ 'CART.ADD_NEW_VARIANT' | translate }}
  </button>
</div>
